export enum StoreState {
  idle = 'idle',
  inProgress = 'inProgress',
  success = 'success',
  error = 'error'
}
